// colorScale - our pre-defined palette
// - should never be exported or accessed directly outside the theme file
// - never use any palette that not included in the palette
// - palette should be referenced by theme usage based sections

import qknPalette from './qknPalette.json';

const qknColors = Object.freeze(qknPalette);

export default qknColors;
